import React, { useState } from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Skeleton,
  Tooltip,
  tooltipClasses,
  styled,
} from '@mui/material';

export const CustomTooltip = styled(({ className, ...props }: any) => (
    <Tooltip {...props} classes={{ popper: className }} arrow />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#F9FAFB',
      color: '#212636',
      fontSize: '14px',
      fontWeight: 400,
      borderRadius: '20px',
      border: "1px solid #DCDFE4",
      padding: '8px 12px',
      whiteSpace: 'pre-line',
      boxShadow: "0px 5px 22px 0px #00000014",
      maxWidth: '600px',  
      width: 'auto', 

    },
    [`& .${tooltipClasses.arrow}`]: {
      color: '#F9FAFB',
    },
  }));
  